import { Effect, Reducer } from 'umi';
import { getUserInfo, getNavMenuList, getNavStudioList } from '@/pages/home/services/home';
import { UserInfoType, NavMenuItemType, INavStudioItem } from '@/pages/home/types/home';
import { storage } from '@/utils/utils';
export const namespace = 'home';

export interface HomeModelStateType {
  userInfo: null | UserInfoType; // 用户信息
  navMenuList: Array<NavMenuItemType>; // 头部导航列表
  navMenuListLoaded: boolean; // navMenuList 接口是否已完成（成功/失败/空均为 true）
  navStudioList: Array<INavStudioItem>; // 头部Studio导航列表
  showGlobalMask: boolean | 'transparent';
}

export interface HomeModelType {
  namespace: string;
  state: HomeModelStateType;
  effects: {
    getUserInfo: Effect;
    getNavMenuList: Effect;
    getNavStudioList: Effect;
  };
  reducers: {
    save: Reducer<HomeModelStateType>;
    // 启用 immer 之后
    // save: ImmerReducer<IndexModelState>;
  };
  // subscriptions: { setup: Subscription };
}

const HomeModel: HomeModelType = {
  namespace,

  state: {
    userInfo: null,
    navMenuList: [],
    navMenuListLoaded: false,
    navStudioList: [],
    showGlobalMask: false,
  },

  effects: {
    // 获取用户信息
    *getUserInfo({ }, { put }) {
      try {
        const result: UserInfoType = yield getUserInfo();

        const { openid } = result;
        if ((window as any).aegis) {
          (window as any).aegis.setConfig({
            uin: openid
          });
        }
        // OIDC 类型有谷歌、okta登录, 需要特殊区分
        !['OIDC'].includes(result.logintype) && storage.setItem('_dbh_login_type', {
          type: result.logintype,
        });

        // 给marketing补充和opinion一样的权限，userInfo也能获取到相同的权限
        const permissions = result?.permissions;
        // if(permissions){
        //   if(permissions.opinion || permissions.opinion_pc){
        //     permissions.marketing = permissions.opinion;
        //     permissions.marketing_pc = permissions.opinion_pc;
        //   }
        // }
        sessionStorage.setItem('permissions', JSON.stringify(permissions));
        sessionStorage.setItem('userName', JSON.stringify(result?.username));
        sessionStorage.setItem('openId', JSON.stringify(result?.openid));
        yield put({
          type: "save", payload: {
            userInfo: result
          }
        });
      } catch (error) {
        console.log('error', error);
      }

    },

    // 获取左侧菜单
    *getNavMenuList({ }, { put }) {
      try {
        const result: NavMenuItemType[] = yield getNavMenuList();
        yield put({
          type: "save", payload: {
            navMenuList: [...result],
            navMenuListLoaded: true,
          }
        });
      } catch (error) {
        console.log('error', error);
        // 接口失败时也标记为已完成，避免菜单永远不渲染
        yield put({ type: "save", payload: { navMenuListLoaded: true } });
      }
    },
    // 获取studio列表
    *getNavStudioList({ }, { put }) {
      try {
        const result: INavStudioItem[] = yield getNavStudioList();
        yield put({
          type: "save", payload: {
            navStudioList: [...result]
            // navMenuList: changeListMenu(result)
          }
        });
      } catch (error) {
        console.log('error', error);
      }

    },
  },
  reducers: {
    save(state: HomeModelStateType, action: any) {
      return {
        ...state,
        ...action.payload,
      };
    },
  }
};

export default HomeModel;
